<template>
  <a>
    <Level_1 v-if="level === 1"></Level_1>
    <Level_2 v-if="level === 2"></Level_2>
    <Level_3 v-if="level === 3"></Level_3>
    <Level_4 v-if="level === 4"></Level_4>
    <Level_5 v-if="level === 5"></Level_5>
    <Level_6 v-if="level === 6"></Level_6>
  </a>
</template>

<script>
    import Level_1 from '../icon/level/Level_1'
    import Level_2 from '../icon/level/Level_2'
    import Level_3 from '../icon/level/Level_3'
    import Level_4 from '../icon/level/Level_4'
    import Level_5 from '../icon/level/Level_5'
    import Level_6 from '../icon/level/Level_6'

    export default {
        name: "LevelIcon",
        components: {Level_1, Level_2, Level_3, Level_4, Level_5, Level_6},
        props: {
            level: {
                type: Number,
                default: 0
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/component/LevelIcon.vue